import AssetInformationList from './CoreAssetInformation';

export default {
  'views.components.assetInformationActions': [{ component: AssetInformationList, key: 'assets' }],
};
